import { useQuery } from '@tanstack/react-query';

import { noticesApi } from '../api/notices.adapter';

export const noticeQueryKeys = {
  all: ['notices'] as const,
  list: () => [...noticeQueryKeys.all, 'list'] as const,
  detail: (id: number) => [...noticeQueryKeys.all, 'detail', id] as const,
};

// PRD 13 §3.1 — full list, unpaginated. Search/sort/pagination run client-side
// (see notices-page.store + filter-sort util).
export function useNoticesQuery() {
  return useQuery({
    queryKey: noticeQueryKeys.list(),
    queryFn: () => noticesApi.list(),
  });
}

// PRD 13 §3.3 — detail fetch when the edit form opens. `id` is null in create
// mode and the query stays disabled so we don't hit the adapter with a sentinel.
export function useNoticeDetailQuery(id: number | null) {
  return useQuery({
    queryKey: noticeQueryKeys.detail(id ?? -1),
    queryFn: () => noticesApi.get(id as number),
    enabled: id !== null,
  });
}
